<template>
  <div class="thousand_layout" v-loading="loading">
    <!--     {{userInfo}}
    <br>
    userInfo
    <br>
    <br>
    {{userDetail}}
    <br>
    userDetail
    <br>
    <br>{{memberInfo}}
    memberInfo -->
    <div class="setting_box">
      <div class="set_box">
        <h3>{{ $t('base.personalInfo') }}</h3>
        <div></div>
        <ul class="set_list">
          <li>
            <div class="set_left align_center">{{ $t('base.profilePic') }}</div>
            <div class="set_right">
              <!-- :imgurl="userInfo.HeadPortrait" -->
              <upload-himages @getDialog="getPass" :userInfo="userInfo" />
            </div>
          </li>
          <li>
            <div class="set_left">{{ $t('base.userName') }}</div>
            <div class="set_right RealName" @click="goto('feedback')">{{userInfo.NickName}}
              <span class="positive" v-if='userDetail!=null'>{{userDetail.BuyFavorableCount+userDetail.SellFavorableCount}}</span>
            </div>
          </li>
          <li>
            <div class="set_left">{{ $t('base.location') }}</div>
            <div class="set_right" v-if="memberInfo!=null">
              <div class="set_edit_box locationBox" v-if="isCountries">
                <div v-if="memberInfo.LocationName!=null">
                  <img class="countries" :src="memberInfo.LocationIcon" alt="">
                  <div>{{memberInfo.LocationName}}</div>
                </div>
                <div v-else>{{ $t('base.chooseLocation') }}</div>
                <span class="text_blue" @click="isCountries=false" v-if="memberInfo.LocationName==null">{{ $t('base.edit') }}</span>
              </div>
              <countries-box @getData="getPass" :list='userInfo' v-if="!isCountries" />
            </div>
          </li>
          <li>
            <!-- 手机号显示和完善 -->
            <div class="set_left">{{$t('base.phoneNumber')}}</div>
            <div class="set_right">
              {{userDetail&&userDetail.Mobile?userDetail.Mobile:''}}
              <div class="set_edit_box" v-if="userDetail&&!userDetail.Mobile">
                <span class="text_blue" @click="SetPhoneOrEmail(0)">{{$t('base.add')}}</span>
              </div>
            </div>
          </li>
          <!-- 新人认证 -->
          <li>
            <div class="set_left">{{$t('kyc.IDVerification')}}</div>
            <div class="set_right" v-if="isUserAuth!=10">
              <div class="set_edit_box idVerify">
                <div class="infoTip" v-if="isUserAuth!=2"><i class="el-icon-warning-outline"></i>&nbsp;{{$t('kyc.24hours3times')}}</div>
                <!-- <span class="text_red" @click="SetIDVerification(1)" >{{$t('kyc.VerifyNow')}}</span> -->
                <!-- <img src="../../../static/images/icon/icon_logo_jumio.png"> -->
                <span class="text_greed" v-if="isUserAuth==2">{{$t('base.completed')}}</span>
                <span class="text_blue" v-if="isUserAuth==1">{{$t('base.processing')}}</span>
                <span class="text_yellow" @click="SetIDVerification(1)" v-if="isUserAuth==3">{{$t('enum.declined')}}</span>
                <span class="text_red" @click="SetIDVerification(0)" v-if="isUserAuth==0">{{$t('kyc.VerifyNow')}}</span>
              </div>
            </div>
          </li>
          <li>
            <!-- 邮箱显示和完善 -->
            <div class="set_left">{{$t('base.email')}}</div>
            <div class="set_right setChange">
              {{memberInfo&&memberInfo.EMail?memberInfo.EMail:''}}
              <div class="set_edit_box" v-if="isEmail">
                <span class="text_blue" @click="SetPhoneOrEmail(1)">{{memberInfo&&memberInfo.EMail?$t('base.change'):$t('base.add')}}</span>
              </div>
            </div>
          </li>
          <li>
            <div class="set_left">{{ $t('base.password') }}</div>
            <div class="set_right">
              <div class="set_edit_box" v-if="isPassword">
                <span class="text_blue" @click="isPassword=false">{{ $t('base.change') }}</span>
              </div>
              <password-box @getData="getPass" :list='userInfo' v-if="!isPassword" />
            </div>
          </li>
          <li>
            <div class="set_left">{{ $t('base.language') }}</div>
            <div class="set_right">
              <change-lang></change-lang>
            </div>
          </li>
          <li>
            <div class="set_left">{{ $t('base.accountType') }}</div>
            <div class="set_right">{{userInfo.IsSeller?$t('base.seller'):$t('base.individual')}}</div>
          </li>
          <li>
            <div class="set_left">{{ $t('base.shippingAddresses') }}</div>
            <div class="set_right">
              <div class="set_smail_box" v-loading="loading">
                <address-box @getData="getPass" :list='newList' :uid='userInfo.Id' :userInfo='userInfo' v-if="isAddress=='new'" />
                <div class="set_smail_line" v-for="(item,index) in address" :key="index" :class="address!=null&&(address.length-1)==index?'isLast':''">
                  <address-box @getData="getPass" :list='list' :uid='userInfo.Id' :userInfo='userInfo' v-if="isAddress==index" />
                  <!-- ,userInfo.Id -->
                  <div v-else>
                    <div class="set_smail_edit">
                      <span class="text_blue" v-if="!item.IsDefault" @click="makePrimary(item,userInfo.Id)">{{ $t('base.makePrimary') }}</span>
                      <span class="text_blue" @click="editAddress(item,index)">{{ $t('base.edit') }}</span>
                      <span class="text_blue" v-if="!item.IsDefault" @click="deleteAddress(item.Id)">{{ $t('base.delete') }}</span>
                    </div>
                    <div class="set_smail_line_box address_list">
                      <div class="set_smail_tag" v-if="item.IsDefault">{{$t('colon.PrimaryAddress')}}</div>
                      <div class="set_smail_tag" v-if="!item.IsDefault">{{$t('colon.otherAddress')}}</div>
                      <div class="set_smail_txt">{{item.UserName}}</div>
                      <div class="set_smail_txt">{{item.StreetAddress}}</div>
                      <div class="set_smail_txt">{{item.StreetAddress2}} {{item.ZipCode}}</div>
                      <div class="set_smail_txt">{{item.Country}} {{item.StateCode}} {{item.City}}</div>
                      <div class="set_smail_txt">{{item.Phone}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- getComeSoon() getIsAddress() -->
              <div class="set_edit_box" v-if="address.length<=0">
                <span class="text_blue" @click="getComeSoon('new')">+ {{ $t('base.addNewAddress') }}</span>
              </div>
            </div>
            <div class="set_edit_box add_item" v-if="address.length>0">
              <span class="text_blue" @click="getComeSoon('new')">+ {{ $t('base.addNewAddress') }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="set_box" v-if="!userInfo.IsSeller">
        <h3 class="Account">{{ $t('base.accountPreferences') }}</h3>
        <ul class="set_list">
          <li>
            <div class="set_left">{{ $t('base.closeAccount') }}</div>
            <div class="set_right">
              <div class="set_edit_box">
                <router-link class="text_blue" :to="{path:'/terms/account'}">{{ $t('base.close') }}</router-link>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- {{iframesrc}}
    <div style="width: 100%;height: 100vh;z-index: 999;top:0;left: 0;">
      <iframe :src="iframesrc" width="100%" height="100%"></iframe>
    </div> -->
    <get-change :title="title" :domVisible='dislogType.changePhone' :type="type" :userInfo="userInfo" @closeDialog="closeDialog" v-if='dislogType.changePhone' />
    <!-- <upload-dialog :dialogClass="dialogBox" @getDialog="getDialog" :domVisible='dislogType.upload' v-if='dislogType.upload' /> -->
    <activity />
  </div>
</template>
<script>
import { getInfo, addressList, setInfo, CensoredEmail,setIDForOther } from "@/api/public";
import PasswordBox from "@/components/form/password";
import EmailBox from "@/components/form/email";
import PhoneBox from "@/components/form/phone";
import AddressBox from "@/components/form/address";
import CountriesBox from "@/components/form/location";
import UploadHimages from '@/components/upload-himages'
import Activity from "@/components/activity/activity1"; // 新人活动
import GetChange from "@/components/dialog/changePhone"; // 修改手机号或邮箱
import changeLang from '@/components/change-lang' // 選擇語言
// import UploadDialog from "@/components/dialog/uploaddialog";

export default {
  name: 'Settings',
  components: { PasswordBox, EmailBox, PhoneBox, AddressBox, CountriesBox, UploadHimages, Activity, GetChange, changeLang },
  props: {},
  data() {
    return {
      iframesrc:'',
      isUserAuth:10,
      nationIconsCode: '',
      title: '',
      type: 0,
      userInfo: null,
      loading: false,
      // isInfo: false,
      dislogType: this.$enumInfo.dislogType,
      userDetail: null,
      memberInfo: null,
      isCountries: true,
      isPassword: true,
      isEmail: false,
      // emailType: 'Verify',
      // isPhone: true,
      isAddress: null,
      // userDate: demo.demo.demo3,
      address: [],
      list: {},
      newList: {},
    }
  },
  filters: {
    //设置时间
    setEmail(val) {
      return CensoredEmail(val)
    },

  },
  mounted() {
    this.getAddressList()
  },
  created() {
    this.userInfo = getInfo();
    //this.showActivty(0)
    this.getNationIcons()
    this.getMemberInfo()
    this.getUserDetail()
  },
  methods: {
    // 新人活动
    showActivty(type, val) {
      let that = this;
      if (process.env.VUE_APP_ACTIVITY) {
        if (type == 0) {
          that.$enumInfo.activtyType.activty = false
        } else {
          if (val == undefined) {
            that.loading = false;
            let newInfo = getInfo();
            if (newInfo.Count < 1) {
              let data = { Memberid: newInfo.Id }
              that.$get(that.$interface.CheckUserIsPrize, data).then(res => {
                if (res.Result != 0) {
                  that.$enumInfo.activtyType.activty = true
                }
              })
            }
          }
        }
      }
    },
    clickDialog(file) {
      let that = this;
      // alert(111)
      //that.dislogType['upload'] = true;
    },
    getDialog(val, res) {
      let that = this;
      //that.dislogType[val] = res;
      // console.log(22222,fileUrl)
    },
    // 关闭弹框
    closeDialog(val, bol, type) {
      //console.log('11111111111111111111111')
      this.dislogType[val] = bol;
      if (type == 1) {
        this.getMemberInfo();
        this.getUserDetail();
      }
    },
    /**
     * 设置手机号或邮箱
     * @param {number} val - 设置类型,0表示添加手机,其他值表示修改邮箱
     * @description 根据传入的val值切换弹窗类型和标题:
     * - val=0时设置为添加手机号
     * - 其他值时设置为修改邮箱
     */
    SetPhoneOrEmail(val) {
      this.dislogType['changePhone'] = true;
      this.title = this.$t('base.changeEmail')
      this.type = 0
      if (val == 0) {
        this.type = 1
        this.title = this.$t('base.addPhone')
      }
    },
    SetIDVerification(val) {
      let that = this
      that.title = this.$t('kyc.IDVerification')
      that.type = val
      if (val == 1) {
        that.title = this.$t('enum.declined');
        that.dislogType['idverification'] = true;
      } else {
        // if(that.userInfo.MemberSource=='US'){
        //   that.dislogType['verifynow'] = true;
        // }else{
    
        //   setIDForOther(that.userInfo)
        // }
          setIDForOther(that.userInfo)
        
      }
    },
    // 关闭并打开其他弹框
    openCloseDialog(openVal,closeVal,openBol,closeBol){

      this.dislogType[openVal] = openBol;
      this.dislogType[closeVal] = closeBol;
    },
    setIsEmail(obj) {
      if (obj.TelPhone) {
        this.isEmail = true
      }
    },
    // EmailType(val){
    //   this.emailType=val;
    //   this.isEmail=false;
    // },
    /**
     * 获取用户详细信息
     * 通过接口请求获取用户详情数据，包括积分、余额、头像等信息
     * 同时更新本地存储的用户信息，并根据认证状态判断是否需要查询认证信息
     * @private
     * @returns {void}
     */
    getUserDetail() {
      let that = this;
      let data = { 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId }
      that.$get(this.$interface.GetUserDetail, data).then(res => {
        if (res.result != 0) {
          let data = res.data;
          that.userDetail = data;
          //console.log('getUserDetail', data)
          setInfo('PointCount', data.PointCount)
          setInfo('SumMoney', data.SumMoney)
          setInfo('HeadPortrait', data.HeadPortrait)
          setInfo('MemberSource', data.MemberSource)
          setInfo('WyAccId', data.WyAccId)
          setInfo('WyToken', data.WyToken)
          setInfo('VerifyStatus', data.VerifyStatus)
          setInfo('AccountId', data.AccountId)
          // 判断是否已认证
          if(data.VerifyStatus==2){
            that.isUserAuth=data.VerifyStatus
          }else{
            //未认证查询状态
            that.getQueryUserAuth()
          }
          //that.getQueryUserAuth()
          if (data.Mobile) {
            setInfo('Mobile', data.Mobile)
          }
          that.userInfo = getInfo();
        }
      })
    },
    /**
     * 获取会员信息并更新本地存储
     * 通过会员ID请求用户详细信息,并将返回的数据保存到本地存储中
     * 包括位置图标、位置名称、邮箱、电话等信息
     * @method getMemberInfo
     * @private
     */
    getMemberInfo() {
      let that = this;
      let data = { memberId: that.userInfo.Id }
      that.$get(this.$interface.GetMemberInfo, data).then(res => {
        if (res.Result != 0) {
          let data = res.Data;
          that.memberInfo = data;
          //console.log('memberInfo', data)
          //setInfo('HeadPortrait',data.HeadPortrait)
          setInfo('LocationIcon', data.LocationIcon)
          setInfo('LocationName', data.LocationName)
          if (data.EMail) {
            setInfo('Mobile', data.EMail)
          }
          if (data.TelPhone) {
            that.userDetail.Mobile = data.TelPhone
            setInfo('Mobile', data.TelPhone)
            setInfo('TelPhone', data.TelPhone)
          }
          that.userInfo = getInfo();
          that.setIsEmail(that.userInfo)
        }
      })
    },
    /**
     * 获取用户地址列表信息
     * 通过 addressList API 获取地址数据，并更新本地存储和组件状态
     * - 存储地址总数到本地
     * - 如果有地址数据，保存第一个地址的州/省信息
     * - 更新组件的 address 数组和加载状态
     * @private
     */
    getAddressList() {
      let that = this;
      addressList().then(res => {
        setInfo('Count', res.Count ? res.Count : 0)
        if (res.Result != 0) {
          // 2022/12/7
          if (res.Count > 0) {
            setInfo('State', res.Data[0].State)
            setInfo('StateCode', res.Data[0].StateCode)
          }
          //
          this.address = res.Data
        }
        this.isAddress = null
        that.loading = false;
      })
    },
    // 设置默认地址
    makePrimary(obj, val) {
      let that = this
      that.loading = true;
      let data = { "id": obj.Id, "memberId": val }
      this.$post(this.$interface.SetDefaultAddresses, data).then(res => {
        if (res.Result != 0) {
          this.getAddressList()
        }
      })
    },
    // 修改地址
    editAddress(obj, val) {
      let that = this
      this.list = JSON.parse(JSON.stringify(obj));
      this.isAddress = val;
    },
    // 删除地址
    deleteAddress(val) {
      let that = this
      that.loading = true;
      var data = { "id": val }
      this.$post(this.$interface.DeleteAddresses, data).then(res => {
        if (res.Result != 0) {
          this.getAddressList()
        }
      })
    },
    // 页面跳转 val feedback
    goto(val) {
      var url = "";
      if (val == 'feedback') {
        url = '/feedback/buyer?id=' + this.userInfo.MappingUserId
      }
      this.$router.push({
        path: url
      })
    },
    /**
     * 获取用户认证状态
     * 通过用户映射ID查询用户的认证信息
     * @method getQueryUserAuth 0=待认证，1=认证待审核，2=成功，3=失败
     * @returns {void}
     * @description 调用接口获取用户认证状态，并更新 isUserAuth 数据
     */
    getQueryUserAuth() {
      let that = this
      that.$get(that.$interface.QueryUserAuth,{Id:that.userInfo.MappingUserId}).then(res => {
        if(res.Result){
          that.isUserAuth=res.Data
        }
      })
    },
    getNationIcons() {
      let that = this
      this.$get(this.$interface.GetAllNationIcons, '').then(res => {
        if (res.Result != 0) {
          var nationIconsCode = []
          res.Data.map(item => {
            nationIconsCode.push(item.Code)
          })
          that.nationIconsCode = nationIconsCode
        }
      })
    },
    // 英，港，澳，台 弹框 comming soon
    /**
     * 处理区域可用性检查
     * @param {boolean} val - 是否显示地址设置
     * @description 根据用户所属区域(MemberSource)判断功能是否可用:
     * - 如果用户区域在支持列表中,则设置地址显示状态
     * - 如果用户区域不支持,则显示"Coming Soon"提示框
     * @private
     */
    getComeSoon(val) {
      let that = this
      var MemberSource = that.userInfo.MemberSource
      if (that.nationIconsCode.indexOf(MemberSource) > -1) {
        // if(MemberSource=="US"||MemberSource=="MO"||MemberSource=="AU"||MemberSource=="GB"||MemberSource=="KR"||MemberSource=="DE"||MemberSource=="FR"||MemberSource=="NL"||MemberSource=="BE"){
        that.isAddress = val
      } else {
        var title = ''
        var html = `<div class="comeBox"><span></span>Coming Soon</div>`
        //MemberSource
        this.$alert(html, title, {
          customClass: 'region ' + MemberSource,
          confirmButtonText: 'I Know',
          dangerouslyUseHTMLString: true,
          showClose: false,
          lockScroll: false,
          callback: action => {

          }
        });
      }
    },
    /**
     * 处理不同类型的用户设置操作
     * @param {Object} obj - 操作对象
     * @param {string} val - 操作类型，可选值: 'password'/'address'/'location'
     * @param {string|number} valId - 地址ID(仅在address类型时使用)
     * @returns {Promise<void>}
     * 
     * password: 显示密码修改界面
     * address: 获取地址列表
     * location: 获取会员信息并显示国家选择
     */
    async getPass(obj, val, valId) {
      let that = this;

      // console.log(obj, val, this.address)
      if (val == 'password') this.isPassword = true;
      // if(val=='email')this.isEmail=true;
      //if(val=='phone')this.isPhone=true;
      if (val == 'address') {
        that.loading = true;
        //this.getAddressList()
        if (obj) {
          await this.getAddressList()

          /** 新人活动 去除 **/
          // this.showActivty(1, valId)
          /** 新人活动 **/


        } else {
          that.loading = false;
        }
        this.isAddress = null;
      }
      if (val == 'location') {
        this.getMemberInfo()
        this.isCountries = true;
      }
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/settings.css";

.address_list .set_smail_txt {
  margin-bottom: 0;
}

.RealName {
  cursor: pointer;
}

.setChange {
  position: relative;
}

.setChange .set_edit_box {
  position: absolute;
  top: 0px;
  right: 0px;
}
.infoTip{
  flex:1;
  text-align: left;
  color: #a0a0a0;
}
/*.uk{

  background-image: url(../static/images/comingsoon/ukbg.png);
}
*/

</style>



// WEBPACK FOOTER //
// src/pages/user/setting.vue